// extracted by mini-css-extract-plugin
export default {"sideBar":"SideBar_sideBar__WFEtf","icon":"SideBar_icon__9KjpH","header":"SideBar_header__M3jwV","navItem":"SideBar_navItem__vrGzc","logo":"SideBar_logo__Bk6U+"};